<ion-content>
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button (click)="close()">
        <ion-icon name="close" size="large"> </ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title style="text-align: center">
      <ion-row>
        <ion-col class="rfr-col-header dark" style="margin-left: 3rem">
          <h3 style="text-align: center">
            {{ title }}
          </h3>
        </ion-col>
      </ion-row>
    </ion-title>
  </ion-toolbar>
  <ion-grid>
    <ion-row>
      <ion-col size="12">
        <ion-card class="default">
          <ion-card-header>
            <ion-card-title> {{ title }} </ion-card-title>
            <p style="color: red">
              *{{ message }}
            </p>
          </ion-card-header>
          <ion-card-content>
            <ion-list *ngIf="rosters">
              <ion-col size="12">
                <ngx-datatable
                  style="margin-top: 20px"
                  #dataTable
                  [rows]="rosters"
                  [messages]="{
                    emptyMessage: 'noDataFound' | translate,
                    totalMessage: 'totalMessage' | translate
                  }"
                  [rowHeight]="'auto'"
                  [headerHeight]="50"
                  [externalPaging]="true"
                  [columnMode]="'force'"
                  [offset]="0"
                  [limit]="rosters.length"
                  [footerHeight]="50"
                  [scrollbarH]="true"
                  [count]="rosters.length"
                  class="material"
                >
                  <ngx-datatable-column [name]="'Roster'" prop="name" [sortable]="false">
                    <ng-template let-column="column" ngx-datatable-header-template>
                      <span>{{ "Roster" }}</span>
                    </ng-template>
                    <ng-template let-row="row" ngx-datatable-cell-template>
                      <span>{{ row.name }}</span>
                    </ng-template>
                  </ngx-datatable-column>
                  <ngx-datatable-column [name]="'Status'" prop="status" [sortable]="false">
                    <ng-template let-column="column" ngx-datatable-header-template>
                      <span>{{ "Status" }}</span>
                    </ng-template>
                    <ng-template let-row="row" ngx-datatable-cell-template>
                      <span>{{ row.status }}</span>
                    </ng-template>
                  </ngx-datatable-column>
                  <ngx-datatable-column [name]="'Actions'" [sortable]="false">
                    <ng-template let-column="column" ngx-datatable-header-template>
                      <span>{{ "Actions" }}</span>
                    </ng-template>
                    <ng-template let-row="row" ngx-datatable-cell-template>
                      <ion-button size="small" fill="outline" (click)="viewRoster(row)">
                        View details
                      </ion-button>
                    </ng-template>
                  </ngx-datatable-column>
                </ngx-datatable>
              </ion-col>
            </ion-list>
          </ion-card-content>
        </ion-card>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
